import React, { memo } from 'react';

import { ContainerIE, RingIE1, RingIE2, WrapperIE } from './Spinner.styles';

export default memo(({ isLoading }: { isLoading: boolean }) => {
  const obtainedClassName = isLoading ? 'container-spinner-active' : 'container-spinner';

  return (
    <ContainerIE isLoading={isLoading} className={obtainedClassName}>
      <WrapperIE>
        <RingIE1 className="spinner__ring-1" />
        <RingIE2 className="spinner__ring-2" />
      </WrapperIE>
    </ContainerIE>
  );
});
